import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import { downloadFile, fileSteamDownload } from '@/utils/download'
import url from "postcss-url";
export default {
  components: { menberMenu },
  data() {
    return {
      userType: 0,
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      titNames: "Account balance",
      titUrls: ",",

      accTab: 2, //显示哪个账户的信息 

      OrderStartTime: '',
      OrderEndTime: '',
      IsState: 1,
      showModal: false,
      Edlit: false,
      Contraband: true,
      FirstName: '',
      LastName: '',
      CVc: '',
      ExpirationDate: '',
      SortStr: 'orderbydesc',
      datelist: false,
      USAmount: 0,
      HKDAmount: 0,

      Credit: '',
      Orderstatus: '0',
      Typestatus: '0',
      TypeOptions: [
        { value: "0", label: "Type" },
        { value: "1", label: "Income" },
        { value: "2", label: "Spending" },
      ],
      statusOptions: [
        { value: "0", label: "Way to trade" },
        { value: "1", label: "Recharge" },
        { value: "2", label: "Pay" },
        { value: "3", label: "Refund" }
      ],
      //分页
      currentPage: 1,//当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数
      datalist: [],
      ordList: [],
      IscheckCredit: '',
      IsCredit: false,
      CheckRecordActive: 1,//控制查询前1月/3月/1年的active的class
      Amount: { UnPayAmountUSD: 0, UnPayAmountHKD: 0, },
      //日期输入处理,结束日期不能大于开始日期
      pickerBeginDateBefore: {
        disabledDate: time => {
          let beginDateVal = this.OrderEndTime;
          if (beginDateVal) {
            return time.getTime() > beginDateVal;
          }
        }
      },
      //日期输入处理，结束日期不能大于开始日期
      pickerBeginDateAfter: {
        disabledDate: time => {
          let beginDateVal = this.OrderStartTime;
          if (beginDateVal) {
            return time.getTime() > beginDateVal;
          }
        }
      },

      isShowTimeIcon: false, //时间排序图标颜色显示

    }


  },
  created() {
    this.GetAmount();
    this.datetime();
    this.GetAmountSash();
    this.GetUSAmount();
  },
  mounted() {
    this.userType = JSON.parse(sessionStorage.getItem("customerInfos")).CustomerOwnerType;
  },

  methods: {
    clkAccTab(val) {
      this.accTab = val
      this.GetAmountSash()
    },
    /*================分页开始==========================*/
    handleSizeChange(val) {
      this.pageSize = val
      this.GetAmountSash()
      //bus.$emit('stripNum',val)
    },
    handleCurrentChange(val) {
      this.currentPage = val;


      this.GetAmountSash()
      //bus.$emit('CurrentPage',val)
    },
    //查询交易记录
    GetAmount() {
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/MyBill/GetCusAmount';
      this.api.param = {
        "QueryType": 0
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          that.Amount.UnPayAmountUSD = res.Results.UnPayAmountUSD;
          that.Amount.UnPayAmountHKD = res.Results.UnPayAmountHKD;
        }
      })
    },
    //查询信用卡
    GetCreditCard() {
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/CreditCard/Query';
      this.api.param = {
        "CardNumber": "",
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          that.ordList = res.Results;
        }
      })

    },
    BankCard(code) {
      var data = code;
      code = data.replace(/\s/g, '').replace(/(\d{4})\d+(\d{4})$/, "**** **** **** $2")
      return code
    },
    TypeName(code) {
      if (code == 1)
        return 'Income'
      if (code == 2)
        return 'Spending'
    },
    TypeSelect() {
      this.GetAmountSash();
    },
    StatusSelect() {
      this.GetAmountSash();
    },
    StatusName(code) {
      if (code == 1)
        return 'Recharge'
      if (code == 2)
        return 'Pay'
      if (code == 3)
        return 'Refund'
    },
    //获取账户余额-交易记录
    GetAmountSash() {
      //判断下时间是否是yyy-mm-dd,是就加上HH mm ss,不是就跳过
      if (this.OrderStartTime && this.OrderStartTime.length < 11) {
        this.OrderStartTime = `${this.OrderStartTime} 00:00:00`
      }
      if (this.OrderEndTime && this.OrderEndTime.length < 11) {
        this.OrderEndTime = `${this.OrderEndTime} 23:59:59`
      }
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/AccountCashUseLog/GetAccountCashUseLog';
      this.api.param = {
        "Currency": that.accTab,
        "TradeTimeStart": that.OrderStartTime,
        "TradeTimeEnd": that.OrderEndTime,
        "TradeModeValue": that.Orderstatus,
        "TradeType": that.Typestatus,
        "createtime": that.SortStr,
        "Skip": that.currentPage,
        "Take": that.pageSize
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          that.datalist = res.Results;
          // that.datalist = that.datalist.filter((item)=>{
          //   return item.Currency == 2
          // });
          that.total = res.Total;
        }
      })
    },

    //导出 按查询结果导出交易记录
    clkExport() {
      //判断下时间是否是yyy-mm-dd,是就加上HH mm ss,不是就跳过
      if (this.OrderStartTime && this.OrderStartTime.length < 11) {
        this.OrderStartTime = `${this.OrderStartTime} 00:00:00`
      }
      if (this.OrderEndTime && this.OrderEndTime.length < 11) {
        this.OrderEndTime = `${this.OrderEndTime} 23:59:59`
      }
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/AccountCashUseLog/ExportAccountCashUseLogEn';
      this.api.param = {
        Currency: that.accTab,
        TradeTimeStart: that.OrderStartTime,
        TradeTimeEnd: that.OrderEndTime,
        TradeModeValue: that.Orderstatus,
        TradeType: that.Typestatus,
        createtime: that.SortStr,
        Skip: that.currentPage,
        Take: that.pageSize
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK && res.ErrorCode == 'C0001') {
          let Name = 'account record_' + new Date().Format('yyyyMMdd')
          let url = this.$apiFileCloud + (res.Results.indexOf('/') === 0 ? '' : '/') + res.Results
          // let url = res.Results
          // downloadFile(url, Name)
          // fileSteamDownload(this, {
          //   FullPath: url, // 路径
          //   CurrentFileName: Name // 文件名称
          // }, Name)
          window.location.href = url
        }
      })
    },
    //查询账户余额
    GetUSAmount() {
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/CustomerInfo/GetAccountCurrencyCash';
      this.api.param = {
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK && res.Results.length > 0) {
          res.Results.forEach(e => {
            if (e.Currency == 2) {
              that.USAmount = e.UsableCash;
            }
            if (e.Currency == 3) {
              that.HKDAmount = e.UsableCash
            }
          });
        }
      })
    },
    // 获取币种符号
    getAmountName(Currency) {
      switch (Currency) {
        case 1:
          return '￥'
        case 2:
          return 'US $'
      }
    },
    Timesort() {
      if (this.SortStr == 'orderbydesc') {
        this.SortStr = 'orderby'
        this.isShowTimeIcon = true
        this.GetAmountSash();
      } else {
        this.SortStr = 'orderbydesc'
        this.isShowTimeIcon = false
        this.GetAmountSash();
      }
    },
    datetime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let endTime = `${year}-${month}-${day}`;
      let nowTime = endTime; // 当前的时间点
      let befDate = new Date(nowDate.getTime() - 30 * 24 * 3600 * 1000);
      let byear = befDate.getFullYear();
      let bmonth = befDate.getMonth() + 1;
      let bday = befDate.getDate();
      let startTime = `${byear}-${bmonth}-${bday}`;
      let weekBeforeTime = startTime; // 向前推迟一月的时间点

      this.OrderStartTime = weekBeforeTime;
      this.OrderEndTime = nowTime;
    },
    //关闭弹窗
    GetClose() {
      this.showModal = false;
      this.Edlit = false;
      this.datelist = false;

      this.FirstName = '';
      this.LastName = '';
      this.CVc = '';
      this.ExpirationDate = '';
      this.Credit = '';
      this.IsCredit = false;
    },
    //打开添加信用卡
    credit() {
      this.showModal = true;
      this.datelist = true;
      this.GetCreditCard();
    },
    Addcredit() {
      this.showModal = true;
      this.datelist = false;
      this.Edlit = true;
    },
    Criacz() {
      window.location.href = "/payment/myPayment"
    },

    //删除信用卡
    delSendBtn(code) {
      this.$confirm('Are you sure to delete this credit card?', 'Delete credit card', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        // showCancelButton:false,//去掉取消按钮
        // showClose:false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.delAPIData(code);
      }).catch(() => {

      });
      return false
    },
    Setmor(code) {
      let that = this;
      this.api.url = this.$api02 + '/api/EbayCustomer/CreditCard/SetDefault';
      this.api.param = {
        "ID": code
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {

          this.GetCreditCard();
        }
      })

    },
    delAPIData(code) {
      let that = this;
      let id = code;
      this.api.url = this.$api02 + '/api/EbayCustomer/CreditCard/Delete';
      this.api.param = {
        "ID": id
      }
      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          this.GetCreditCard();
        }
      })
    },
    luhnCheck() {
      var cardNumber = this.Credit;
      var oddSum = 0;
      var evenSum = 0;
      var i = 0;
      cardNumber = cardNumber.split("").reverse().join("");
      for (i = 0; i < cardNumber.length; i++) {
        if (i % 2 == 0) {
          oddSum += parseInt(cardNumber[i]);
        }
        else {
          var num = parseInt(cardNumber[i]) * 2;
          num = num > 9 ? parseInt(num.toString()[0]) + parseInt(num.toString()[1]) : num;
          evenSum += num;
        }
      }
      // if((oddSum + evenSum) % 10 == 0){
      //   return true;
      // }else{
      //   return false
      // }
      return (oddSum + evenSum) % 10 == 0;
    },
    //验证信用卡
    checkCredit() {
      var bankno = this.Credit;
      var lastNum = bankno.substr(bankno.length - 1, 1);//取出最后一位（与luhn进行比较）
      var first15Num = bankno.substr(0, bankno.length - 1);//前15或18位
      var newArr = new Array();
      for (var i = first15Num.length - 1; i > -1; i--) {    //前15或18位倒序存进数组
        newArr.push(first15Num.substr(i, 1));
      }
      var arrJiShu = new Array();  //奇数位*2的积 <9
      var arrJiShu2 = new Array(); //奇数位*2的积 >9

      var arrOuShu = new Array();  //偶数位数组
      for (var j = 0; j < newArr.length; j++) {
        if ((j + 1) % 2 == 1) {//奇数位
          if (parseInt(newArr[j]) * 2 < 9)
            arrJiShu.push(parseInt(newArr[j]) * 2);
          else
            arrJiShu2.push(parseInt(newArr[j]) * 2);
        }
        else //偶数位
          arrOuShu.push(newArr[j]);
      }

      var jishu_child1 = new Array();//奇数位*2 >9 的分割之后的数组个位数
      var jishu_child2 = new Array();//奇数位*2 >9 的分割之后的数组十位数
      for (var h = 0; h < arrJiShu2.length; h++) {
        jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
        jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
      }

      var sumJiShu = 0; //奇数位*2 < 9 的数组之和
      var sumOuShu = 0; //偶数位数组之和
      var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
      var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
      var sumTotal = 0;
      for (var m = 0; m < arrJiShu.length; m++) {
        sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
      }

      for (var n = 0; n < arrOuShu.length; n++) {
        sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
      }

      for (var p = 0; p < jishu_child1.length; p++) {
        sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
        sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
      }
      //计算总和
      sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

      //计算luhn值
      var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
      var luhn = 10 - k;

      if (lastNum == luhn) {
        this.IscheckCredit = false;


      } else {

        this.IscheckCredit = true;
      }
      if (this.Credit.length < 16) {
        this.IscheckCredit = true;
      } else {
        this.IscheckCredit = false;
      }
    },
    //验证cvc
    Cvccheck() {
      var reg = /^\d{3,4}$/;
      if (!reg.test(this.CVc)) { //只能输入邮箱格式
        this.IsCredit = true;
      } else {
        this.IsCredit = false;
      }

    },
    //保存信用卡 
    SaveCard() {
      let that = this;
      if (!that.luhnCheck || !that.FirstName || !that.LastName || !that.CVc || !that.ExpirationDate) {

        that.IsCredit = true;
        return false;
      }
      if (!(that.Credit.length <= 16)) {
        that.IsCredit = true;
        return false;
      }
      let Isdefa = false;
      if (this.Contraband) {
        Isdefa = true;
      }
      this.api.url = this.$api02 + '/api/EbayCustomer/CreditCard/AddCreditCard';
      this.api.param = {
        "FirstName": that.FirstName,
        "LastName": that.LastName,
        "IsDefault": Isdefa,
        "CardNumber": that.Credit,
        "CVC": that.CVc,
        "ExpirationDate": that.ExpirationDate,
      }

      post(this.api.url, this.api.param).then((res) => {
        if (res.ErrorCode == 'C0001') {
          that.GetClose();
        } else {
          that.IsCredit = true;
        }
      })
    },
    //查询 一个月/三个月/一年前的记录
    CheckRecord(monthData) {
      let that = this;
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let nowTime = `${year}-${month}-${day}`;
      // 当前的时间
      this.OrderEndTime = nowTime;
      // 一个月/三个月/一年前的开始时间
      let weekBeforeTime = that.GetMonth(monthData)
      this.OrderStartTime = weekBeforeTime;
      this.CheckRecordActive = Math.abs(monthData);
      // 调用查询接口
      this.GetAmountSash()

    },
    GetMonth(monthData) {
      let time = new Date();
      time.setMonth(time.getMonth() + monthData);//设置month月后的时间
      let y = time.getFullYear();
      let m = time.getMonth() + 1;//获取当前月份
      let d = time.getDate();
      return `${y}-${m}-${d}`;
    },

  }

};


// WEBPACK FOOTER //
// ./src/assets/js/userCenter/payment/myAccount.js